import styled from 'styled-components';
import { Nest } from 'ui/icons/action/Nest';
import { colors, spacing } from 'ui/theme';

// Filter
export const StyledNest = styled(Nest)`
  color: ${colors.textSecondary};
  margin-right: ${spacing.base};
`;

// Filter List
export const AddButtonPrefix = styled.div`
  display: inline-block;
  width: ${spacing.plusHalf};
  margin-left: ${spacing.quarter};
  margin-right: ${spacing.base};
`;
